/** One tenancy-resolved policy supplies badge grading and read visibility. */
import * as React from "react";
import { ConfidenceCutoffsProvider, ReadConfidenceProvider, useConfidencePolicy } from "@authe/ui-core";
import { readConfidencePolicy, type TierCutoffs } from "@authe/fe-commons/evidence";
import { useEvidencePolicySource } from "@/api/adapters";

export function DashboardConfidenceCutoffs({ children }: { children: React.ReactNode }): React.ReactElement {
  const source = useEvidencePolicySource();
  const { data, status } = useConfidencePolicy(source);
  const effective = data?.effective;
  const raw = effective?.tier_cutoffs;
  const scoped = raw && typeof raw === "object" ? raw as Partial<TierCutoffs> : null;
  const cutoffs = scoped ? {
    high: typeof scoped.high === "number" ? scoped.high : undefined,
    medium: typeof scoped.medium === "number" ? scoped.medium : undefined,
  } : null;
  const policy = React.useMemo(() => readConfidencePolicy(effective), [effective]);
  return <ConfidenceCutoffsProvider cutoffs={cutoffs}>
    <ReadConfidenceProvider policy={policy} loading={!data && status !== "error"}>
      {children}
    </ReadConfidenceProvider>
  </ConfidenceCutoffsProvider>;
}
